// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1178":"d2db8a5d","5504":"c46410c0","7631":"d5bffa5f"}[chunkId] + ".chunk.css";
};